module.exports = __webpack_public_path__ + "static/media/founder1.d594b7dc.png";